module.exports = "https://cdn.dove.it/_next/static/public/assets/come-funziona-consulenza-aste.31795cc74f43b444c05373234a2a7910.png";